/*
 *
 * File: App.jsx
 *
 * Purpose: Multistop App start component.
 *
 * Autor:   Thomas Burgard (Software development)
 * Created: 22.02.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import CheckUserScreen from "./screens/CheckUserScreen";
import ProtectedRoute from "./screens/ProtectedRoute";
import { screenIdent } from "./utils/dataObjects";
import { getUserNameFromURL } from "./utils/utils";

// Necessary for Stipe payment process
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import "react-toastify/dist/ReactToastify.css";

//--------------------------------------------------------------
//--- Variable declarations ------------------------------------
//--------------------------------------------------------------
/*const stripePromise = loadStripe(
  "pk_live_51Ok2KxI7lflkN3141Ho0uupslilmSi09DCjbON6NUwWWBOvBWvscgNB6sMkaeD9Fira98MPPRKPGSE2LHlQuzxKr00l38K7wae"
);*/

/**
 * Implementation of DrivePartner booking app
 * component with routes.
 */
const App = () => {
  //--------------------------------------------------------------
  //--- REDUX ----------------------------------------------------
  //--------------------------------------------------------------  
  const dispatch = useDispatch();

  /**
   * Check if user exists in server database after mounted component.
   * Make API access with url part "username".
   *
   * @returns boolean true if user exists otherwise false
   */
  useEffect(() => {
    // Get browser URL to fetch user name
    const url = window.location.href;

    // Fetch user name from browser url
    const user = getUserNameFromURL(url);

    // Call Redux action to fetch user data from server
    //dispatch(getUserData(user));
  }, []);

  //--------------------------------------------------------------
  //--- Returns JSX code for "App" -------------------------------
  //--------------------------------------------------------------
  return (
     
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <CheckUserScreen screenIdent={screenIdent.bookingScreen} />
            }
          />
          <Route
            path="/fixpriceroutes"
            element={
              <CheckUserScreen screenIdent={screenIdent.fixPriceRoutesScreen} />
            }
          />
          <Route
            path="/changeyourbooking"
            element={
              <CheckUserScreen screenIdent={screenIdent.changeBookingScreen} />
            }
          />
          <Route
            path="/customerinfo"
            element={<CheckUserScreen screenIdent={screenIdent.customerInfo} />}
          />
          <Route
            path="/legalnotice"
            element={<CheckUserScreen screenIdent={screenIdent.legalNotice} />}
          />
          <Route
            path="/dataprotection"
            element={
              <CheckUserScreen screenIdent={screenIdent.dataProtection} />
            }
          />
          <Route
            path="/termsofuse"
            element={<CheckUserScreen screenIdent={screenIdent.termsOfUse} />}
          />
          <Route
            path="/passengerlogin"
            element={
              <CheckUserScreen screenIdent={screenIdent.passengerLoginScreen} />
            }
          />
          <Route
            path="/passengerregister"
            element={
              <CheckUserScreen
                screenIdent={screenIdent.passengerRegisterScreen}
              />
            }
          />
          <Route
            path="/bookingtest"
            element={
              <CheckUserScreen screenIdent={screenIdent.bookingTestScreen} />
            }
          />
          <Route
            element={
              <ProtectedRoute>
                <CheckUserScreen screenIdent={screenIdent.sharedLayout} />
              </ProtectedRoute>
            }
          >
            <Route
              path="/passengerstart"
              element={
                <CheckUserScreen
                  screenIdent={screenIdent.passengerStartScreen}
                />
              }
            />
            <Route
              path="/passengeracceptbookings"
              element={
                <CheckUserScreen
                  screenIdent={screenIdent.passengerAcceptBookingsScreen}
                />
              }
            />
            <Route
              path="/passengeracceptbookingsdetails"
              element={
                <CheckUserScreen
                  screenIdent={screenIdent.passengerAcceptBookingsDetailsScreen}
                />
              }
            />
          </Route>
        </Routes>
        <ToastContainer position="top-center" />
      </BrowserRouter>
    
  );
};

export default App;
